import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, signal } from "@angular/core";
import { DateTime } from "@ankaadia/ankaadia-shared";
import { ActivityFragment, NotificationSettingsFragment } from "@ankaadia/graphql";
import { TranslocoService } from "@jsverse/transloco";
import { Drawer } from "primeng/drawer";
import { NewUiSidebarAdditionalComponentDirective } from "../../../shared/primeng/sidebar-additional-component/new-ui-sidebar-additional-component.directive";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiActivityTableComponent } from "../../activity/activity-table/new-ui-activity-table.component";
import { NewUiNotificationConfigurationComponent } from "../notification-configuration/new-ui-notification-configuration.component";

@Component({
  selector: "new-ui-notification-list-dialog",
  templateUrl: "./new-ui-notification-list-dialog.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TranslateDirective,
    NewUiActivityTableComponent,
    NewUiNotificationConfigurationComponent,
    Drawer,
    NewUiSidebarAdditionalComponentDirective,
  ],
})
export class NewUiNotificationListDialogComponent {
  readonly language = this.transloco.getActiveLang();

  @Input()
  notifications: ActivityFragment[];

  @Input()
  since: DateTime;

  @Input()
  settings: NotificationSettingsFragment;

  @Input()
  isBusy: boolean;

  @Output()
  readonly settingsChanged = new EventEmitter<NotificationSettingsFragment>();

  @Output()
  readonly notificationCleared = new EventEmitter<ActivityFragment>();

  @Output()
  readonly allNotificationsCleared = new EventEmitter<void>();

  @Output()
  readonly activityLogOpened = new EventEmitter<void>();

  @Output()
  readonly closed = new EventEmitter<void>();

  configVisible = signal<boolean>(false);

  constructor(private readonly transloco: TranslocoService) {}

  showDialog(): void {
    this.configVisible.set(true);
  }
}
